
import { setUser } from "../utils/comman/Common";

 import { ToastContainer, toast } from "react-toastify";
import { v4 as uuid } from "uuid";
import moment from "moment";
import axiosinstances from "../Helper/useAxios";

async function userLogin(creds) {
  const [axiosInstance] = axiosinstances()
  const date = moment().toDate();
  const unique_id = uuid;
return axiosInstance
.post(`/api/v1/retailer/login`, {
  header: {
    msgType: "LOGIN",

    service: "ADMIN_WEB",

    channel: "ADMIN",

    //requesterId: "ankursaxena",

    requestId: unique_id,

    time: date,
  },
  credentials: {
    user: {
      id: creds.values.id,

      role: "RETAILER",
    },

    pass: creds.values.password,
  },
})
.then((response) => {
  if (response.data.response.success) {
    const result = response.data.token;
    if (result) {
      setUser(result,creds.values.id);
    }

    return response.data;
  }

   toast.error(response.data.response.displayMsg);
  return false;
})
.catch((err) => {
 //console.log(err);
});

  // return axios
  //   .post(
  //     "http://qa.finxpay.co.in/api/v1/retailer/login",

  //     {
  //       header: {
  //         msgType: "LOGIN",

  //         service: "ADMIN_WEB",

  //         channel: "ADMIN",

  //         requesterId: "ankursaxena",

  //         requestId: unique_id,

  //         time: date,
  //       },
  //       credentials: {
  //         user: {
  //           id: creds.values.id,

  //           role: "RETAILER",
  //         },

  //         pass: creds.values.password,
  //       },
  //     }
  //   )
  //   .then((response) => {
  //     if (response.data.response.success) {
  //       const result = response.data.token;
  //       if (result) {
  //         setUser(result,creds.values.id);
  //       }

  //       return response.data;
  //     }

  //      toast.error(response.data.response.displayMsg);
  //     return false;
  //   });
}
export default userLogin;
